/**
 * Plan enablement flag names used to gate hasFeature() and hasFeatureAccess().
 * All listed flags are merged when determining if a feature is enabled by plan.
 * `hasFeature` / `hasFeatureAccess` gate by **`(product, feature)`** pairs from org or asset
 * entitlements (not “feature anywhere” in the merged map). No plans are enabled by default
 * when flags are unset in LaunchDarkly.
 *
 * Flag values are objects mapping product codes to feature code arrays (e.g.
 * { OST: ['MAPS', 'TELE'], OSS: ['RVDE'] }). Flags may be added or removed over
 * time; the resolver supports any combination of such values (single or multiple
 * products per flag, empty feature arrays, multiple flags contributing to the
 * same product with conflict logging).
 */
export const PLAN_ENABLEMENT_FLAG_NAMES = {
  ONSTAR_TELEMATICS_PLAN: 'CSP-Enablement-OnStar-Telematics-Plan',
  ONSTAR_PROTECT_PLAN: 'CSP-Enablement-OnStar-Protect-Plan',
  ONSTAR_CONNECT_PLUS_PLAN: 'CSP-Enablement-OnStar-Connect-Plus-Plan',
  ONSTAR_ONE_FLEET_PLAN: 'CSP-Enablement-OnStar-One-Fleet-Plan',
  ONSTAR_VIDEO_TELEMATICS_PLAN: 'CSP-Enablement-OnStar-Video-Telematics-Plan',
  ONSTAR_STOLEN_VEHICLE_ASSISTANCE_PLAN:
    'CSP-Enablement-OnStar-Stolen-Vehicle-Assistance-Plan',
  ONSTAR_WIFI_PLAN: 'CSP-Enablement-OnStar-Wifi-Plan',
  ONSTAR_TELEMATICS_PLAN_MX: 'CSP-Enablement-OnStar-Telematics-Plan-MX',
  ONSTAR_PROTECT_PLAN_MX: 'CSP-Enablement-OnStar-Protect-Plan-MX',
  BPS_MARKETPLACE: 'CSP-Enablement-BPS-Marketplace',
} as const;

/**
 * List of plan enablement flag keys to check when gating feature access.
 * Used with getMergedPlanEnablement() / createPlanProductEnablementChecker() from
 * this package's enablement module. Extend or reduce this list as flags are
 * added or removed in LaunchDarkly.
 */
export const PLAN_ENABLEMENT_FLAG_NAMES_LIST: string[] = [
  PLAN_ENABLEMENT_FLAG_NAMES.ONSTAR_TELEMATICS_PLAN,
  PLAN_ENABLEMENT_FLAG_NAMES.ONSTAR_PROTECT_PLAN,
  PLAN_ENABLEMENT_FLAG_NAMES.ONSTAR_CONNECT_PLUS_PLAN,
  PLAN_ENABLEMENT_FLAG_NAMES.ONSTAR_ONE_FLEET_PLAN,
  PLAN_ENABLEMENT_FLAG_NAMES.ONSTAR_VIDEO_TELEMATICS_PLAN,
  PLAN_ENABLEMENT_FLAG_NAMES.ONSTAR_STOLEN_VEHICLE_ASSISTANCE_PLAN,
  PLAN_ENABLEMENT_FLAG_NAMES.ONSTAR_WIFI_PLAN,
  PLAN_ENABLEMENT_FLAG_NAMES.ONSTAR_TELEMATICS_PLAN_MX,
  PLAN_ENABLEMENT_FLAG_NAMES.ONSTAR_PROTECT_PLAN_MX,
];
